const styles = {

    "surprise_me": {
        "name": "Surprise me!",
        "description": "<p>At minimum you will receive shaded half-bodies with a suggestion/\"feel\" of a scene. These examples are typically what you'd get at the base price.</p><p>As there will be no sketch check, do mention a few pose/background/atmosphere ideas in the order to ensure you're getting what you want. You can request changes before finalising the artwork.</p><p>If I find the scene concept easy to draw or have a clear idea, I might draw full bodies or a more elaborate piece. If you add a tip, I'm likely to draw a full body or a more polished background.</p>",
        "display_image": {
            "full": "https://circlejourney.net/commissions/images/surprise_8.jpg",
            "thumbnail": "https://circlejourney.net/commissions/images/surprise_8.jpg"
        },
        "variants": [
            {
                "name": "Basic",
                "base_price": 50,
                "description": "",
                "addons": [
                    {
                        "name": "Add character",
                        "price": 35
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_6.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_6.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_8.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_8.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_5.jpg"
                    }
                ]
            },
            {
                "name": "With extras (same base price)",
                "base_price": 50,
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_8.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_8.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_extra_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_extra_5.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_extra_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_extra_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_extra_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_extra_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_extra_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_extra_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/surprise_extra_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/surprise_extra_4.jpg"
                    }
                ]
            }
        ]
    },
    
    "pen_sketch": {
        "name": "Pen Sketch",
        "display_image": {
            "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_5.jpg",
            "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_5.jpg"
        },
        "variants": [
            {
                "name": "Monochrome half-body",
                "description": "Unshaded sketches with one accent hue or a coloured background.",
                "base_price": 20,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 13
                    },
                    {
                        "name": "Detail",
                        "price": 5,
                        "header_suffix": " (max. per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_7.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_7.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_5.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_6.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_half_6.jpg"
                    }
                ]
            },
            {
                "hide": true,
                "name": "Monochrome full-body",
                "description": "Unshaded sketches with one accent hue or a coloured background.",
                "base_price": 30,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 20
                    },
                    {
                        "name": "Detail",
                        "price": 5,
                        "header_suffix": " (max. per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_monochrome_full_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_monochrome_full_1.jpg"
                    }
                ]
            },
            
            {
                "name": "Coloured half-body",
                "description": "Full colour unshaded sketches. Add rim light shading for a small fee!",
                "base_price": 30,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 13
                    },
                    {
                        "name": "Detail",
                        "price": 5,
                        "header_suffix": " (max. per character)"
                    },
                    {
                        "name": "Rim light shading",
                        "price": 6,
                        "header_suffix": " (per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_5.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_6.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_6.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_7.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_7.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_shade_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_shade_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_half_shade_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_half_shade_2.jpg"
                    }
                ]
            },
            
            {
                "name": "Coloured full-body",
                "description": "Full colour unshaded sketches. Add rim light shading for a small fee!",
                "base_price": 30,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 13
                    },
                    {
                        "name": "Detail",
                        "price": 5,
                        "header_suffix": " (max. per character)"
                    },
                    {
                        "name": "Rim light shading",
                        "price": 6,
                        "header_suffix": " (per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/pensketch_colour_full_shade_3.jpg"
                    }
                ]
            }
        ]
    },
    "chibi": {
        "name": "Chibi",
        "display_image": {
            "full": "https://circlejourney.net/commissions/images/chibi_1.png",
            "thumbnail": "https://circlejourney.net/commissions/images/chibi_1.png"
        },
        "variants": [
            {
                "name": "Chibi",
                "description": "Bite-sized chibis.",
                "base_price": 18,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 14
                    },
                    {
                        "name": "Add 3 characters",
                        "price": 42
                    },
                    {
                        "name": "Detail",
                        "price": 10,
                        "header_suffix": " (max. per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/chibi_1.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/chibi_1.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/chibi_2.png",
                        "thumb": "https://circlejourney.net/commissions/images/chibi_2.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/chibi_3.png",
                        "thumb": "https://circlejourney.net/commissions/images/chibi_3.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/chibi_4.png",
                        "thumb": "https://circlejourney.net/commissions/images/chibi_4.png"
                    }
                ]
            },
            
            {
                "name": "Pair chibi (2 characters)",
                "base_price": 40,
                "description": "Two chibis against a simple background inset in a circle.",
                "addons": [
                    {
                        "name": "Detail",
                        "price": 10,
                        "header_suffix": " (max. per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/pairchibi_1.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/pairchibi_1.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pairchibi_2.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/pairchibi_2.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pairchibi_3.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/pairchibi_3.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/pairchibi_4.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/pairchibi_4.png"
                    }
                ]
            },
            
            {
                "hide": true,
                "name": "Polished chibi",
                "base_price": 25,
                "description": "Higher resolution, with extra shiny and detailed shading, and background props!",
                "addons": [
                    {
                        "name": "Add character",
                        "price": 18
                    },
                    {
                        "name": "Detail",
                        "price": 10,
                        "header_suffix": " (max. per character)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/polishedchibi_1.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/polishedchibi_1.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/polishedchibi_2.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/polishedchibi_2.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/polishedchibi_3.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/polishedchibi_3.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/polishedchibi_4.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/polishedchibi_4.png"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/polishedchibi_5.png",
                        "thumbnail": "https://circlejourney.net/commissions/images/polishedchibi_5.png"
                    }
                ]
            }
        ]
    },
    
    "painting": {
        "name": "Painting",
        "display_image": {
            "full": "https://circlejourney.net/commissions/images/semipainting_illust_2.jpg",
            "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_2.jpg"
        },
        "variants": [
            {
                "name": "Abstract background",
                "base_price": 120,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 40
                    },
                    {
                        "name": "Detail",
                        "price": 50,
                        "header_suffix": " (max. per art piece)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/semipainting_illust_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/semipainting_illust_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_4.jpg"
                    }
                ]
            },
            
            {
                "name": "Scene background",
                "base_price": 150,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 40
                    },
                    {
                        "name": "Detail",
                        "price": 60,
                        "header_suffix": " (max. per art piece)"
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/semipainting_illust_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/semipainting_illust_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/semipainting_illust_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/semipainting_illust_6.jpg"
                    }
                ]
            },
            {
                "name": "Full painting",
                "base_price": 170,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 60
                    },
                    {
                        "name": "Detail",
                        "header_suffix": " (max. per art piece)",
                        "price": 80
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/fullpainting_illust_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/fullpainting_illust_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/fullpainting_illust_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/fullpainting_illust_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/fullpainting_illust_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/fullpainting_illust_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/fullpainting_illust_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/fullpainting_illust_4.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/fullpainting_illust_5.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/fullpainting_illust_5.jpg"
                    }
                ]
            }
        ]
    },
    
    
    "clean_shaded": {
        "name": "Clean shaded",
        "display_image": {
            "full": "https://circlejourney.net/commissions/images/cleanshade_full_1.jpg",
            "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_full_1.jpg"
        },
        "variants": [
            {
                "name": "Half body",
                "base_price": 45,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 34
                    },
                    {
                        "name": "Detail",
                        "header_suffix": " (max. per art character)",
                        "price": 15
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_half_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_half_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_half_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_half_2.jpg"
                    }
                ]
            },
            
            {
                "name": "Full body",
                "base_price": 60,
                "addons": [
                    {
                        "name": "Add character",
                        "price": 45
                    },
                    {
                        "name": "Detail",
                        "header_suffix": " (max. per character)",
                        "price": 15
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_full_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_full_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_full_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_full_2.jpg"
                    }
                ]
            },
            
            {
                "name": "Abstract background",
                "base_price": 140,
                "description": "Cel shading with or without out lines (your choice). Check <a href='#abstract-scene'>guidelines below</a> for more about what is meant by an 'abstract' background. Base price includes one character",
                "addons": [
                    {
                        "name": "Add character",
                        "price": 45
                    },
                    {
                        "name": "Background only",
                        "price": -45
                    },
                    {
                        "name": "Detail",
                        "header_suffix": " (max. per art piece)",
                        "price": 60
                    }
                ],
                "images": [
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_1.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_1.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_2.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_2.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_3.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_3.jpg"
                    },
                    {
                        "full": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_4.jpg",
                        "thumbnail": "https://circlejourney.net/commissions/images/cleanshade_illust_abstract_4.jpg"
                    }
                ]
            }
        ]
    }
}

export default styles;